import { computed, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BusinessSettingsStore {
  private readonly state = signal({
    currencyCode: 'EUR',
    timeZone: 'Europe/Madrid'
  });

  readonly currencyCode = computed(() => this.state().currencyCode);
  readonly timeZone = computed(() => this.state().timeZone);
  readonly currencySymbol = computed(() => {
    const code = this.currencyCode();
    const formatter = new Intl.NumberFormat('es-ES', { style: 'currency', currency: code });
    const parts = formatter.formatToParts(0);
    const symbolPart = parts.find(part => part.type === 'currency');
    return symbolPart?.value || code;
  });

  setCurrencyCode(code: string): void {
    this.state.update(current => ({ ...current, currencyCode: code }));
  }

  setTimeZone(timeZone: string): void {
    this.state.update(current => ({ ...current, timeZone }));
  }

  loadFromApi(data: { currencyCode: string; timeZone: string }): void {
    this.state.set({
      currencyCode: data.currencyCode,
      timeZone: data.timeZone
    });
  }
}